import { render } from "./PagePaciente.vue?vue&type=template&id=26245db2&scoped=true"
import script from "./PagePaciente.vue?vue&type=script&lang=js"
export * from "./PagePaciente.vue?vue&type=script&lang=js"

import "./PagePaciente.vue?vue&type=style&index=0&id=26245db2&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26245db2"]])

export default __exports__